import Vue from "vue";
import base from "./baseCore";

const buildQueryParams = (filters) => {
    return {
        resposta: filters.answer,
        tipoEstatisticaCampanha: filters.mode,
        ordem: filters.order,
        desc: filters.desc,
        "data.min": filters.date.min,
        "data.max": filters.date.max,
        aparelhos: filters.devices,
        locals: filters.local
    };
};

export default Object.assign(
    {
        apiUrl: "/campaign",

        async list({ page, filters }) {
            const url = this.url(
                `/${filters.advertisingId}/interaction/${filters.interactionId}/statistics/leads/${page}`
            );
            const query = buildQueryParams(filters);
            return await Vue.http.get(url, {
                params: query,
            });
        },

        async csv({ filters }) {
            const url = this.url(
                `/${filters.advertisingId}/interaction/${filters.interactionId}/statistics/leads/csv`
            );
            return Vue.http({
                url: url,
                method: "GET",
                responseType: "blob",
                params: buildQueryParams(filters),
            });
        },
    },
    base
);
